
import { ModelSelect, ModelListSelect  } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

import DATA_MASTER from  '../../library/dataMaster'

export default {
    components: {
      ModelSelect, ModelListSelect, 
    },
  
  data() {
    return {

      form : {
        id : '',
      },

      dataku: {
          id : '',
          unit_kerja_id : '',
          unit_kerja : '',
      },

      filterku : {
        instansi : '',
        unit_kerja : '',
        fileStat : false,
      },
     
      list_data : [],

      page_first: 1,
      page_last: 0,
      page_limit: 10,
      cari_value: "",
      cek_load_data : true,


      mdl_add: false,
      mdl_edit: false,
      mdl_hapus : false,
      btn_add: false,

      DATA_MASTER : DATA_MASTER,
    }
  },
  methods: {
    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_MasterOpdPiket + "view", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.$store.commit("hideLoading");
              // console.log(res_data);
      });
    },

    onInstansiChange : function(instansiId) {
      this.DATA_MASTER.getUnitKerja(instansiId);
      this.dataku.unit_kerja_id = '';
      this.dataku.unit_kerja = '';
    },

    pilihSubUnitKerja : function(val) {
      var selected = this.$store.state.list_unit_kerja.find(item => item.id == val);
      if (selected) {
        this.dataku.unit_kerja_id = selected.id;
        this.dataku.unit_kerja = selected.unit_kerja;
      } else {
        this.dataku.unit_kerja_id = '';
        this.dataku.unit_kerja = '';
      }
    },

    addData : function(number) {
      if (!this.dataku.unit_kerja && this.dataku.unit_kerja_id) {
        var selected = this.$store.state.list_unit_kerja.find(item => item.id == this.dataku.unit_kerja_id);
        if (selected) {
          this.dataku.unit_kerja = selected.unit_kerja;
        }
      }

      console.log("Data yang dikirim ke backend:", {
        unit_kerja_id: this.dataku.unit_kerja_id,
        unit_kerja: this.dataku.unit_kerja
      });

      this.btn_add = true;
      fetch(this.$store.state.url.URL_MasterOpdPiket + "Add", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            unit_kerja_id: this.dataku.unit_kerja_id,
            unit_kerja: this.dataku.unit_kerja
          })
      })
      .then(res => res.json())
      .then(res_data => {
          this.btn_add = false;
          if (res_data.status === 'SUKSES') {
            this.Notify(res_data.ket || 'Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.mdl_add = false;
            this.getView();
          } else {
            this.Notify(res_data.ket || 'Gagal Menambah Data', 'negative', 'warning');
          }
      })
      .catch(err => {
          this.btn_add = false;
          console.error(err);
          this.Notify('Terjadi kesalahan koneksi', 'negative', 'warning');
      });
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_MasterOpdPiket + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : this.form.id})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },
    selectData : function(data){
        this.form.id = data.id;
        this.form.uraian = data.uraian;
        this.form.keterangan = data.keterangan;
    },

    indexing : function(index){
        var idx = ((this.page_first-1)*this.page_limit)+index
        return idx;
    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },


    // ====================================== PAGINATE ====================================







  },

  mounted () {
    var get_profile = JSON.parse(localStorage.profile);
    this.filterku.unit_kerja = get_profile.profile.unit_kerja;
    this.filterku.instansi = get_profile.profile.instansi_id;
    this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
    this.unit_kerja = get_profile.profile.unit_kerja;
    this.dataku.unit_kerja_id = get_profile.profile.unit_kerja;
    this.dataku.unit_kerja = get_profile.profile.unit_kerja_nama;

    DATA_MASTER.getInstansi();
    DATA_MASTER.getUnitKerja(this.filterku.instansi);

    this.getView();
  },
}
